var s = (r, i, t) => new Promise((c, e) => {
  var g = (n) => {
    try {
      o(t.next(n));
    } catch (a) {
      e(a);
    }
  }, m = (n) => {
    try {
      o(t.throw(n));
    } catch (a) {
      e(a);
    }
  }, o = (n) => n.done ? c(n.value) : Promise.resolve(n.value).then(g, m);
  o((t = t.apply(r, i)).next());
});
import { selfAxios as p } from "@oppein/op-utils";
function u(r) {
  return s(this, null, function* () {
    const {
      data: i
    } = yield p.post(
      "/production-order/engineering/EngineeringForeignTransmit/batchTransmit",
      r
    );
    return i;
  });
}
export {
  u as postBatchTransmit
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/engineering/EngineeringForeignTransmit/batchTransmit/post.js
// module id = 1826
// module chunks = 67